import { assertNever } from 'office-ui-fabric-react';
import { YAxisConfig } from '../../../../../../domain';
import { convertStringToNumber } from '../../../../lib/util';

interface UpdateYAxisLimit {
    type: 'updateYAxisLimit';
    property: 'yAxisMinimumValue' | 'yAxisMaximumValue';
    value: string;
}

export type MultipleYAxesActions =
    | { type: 'setColumn'; column: string }
    | { type: 'setLabel'; label: string }
    | UpdateYAxisLimit
    | { type: 'setYAxisScale'; yAxisScale: 'linear' | 'log' };

export const multipleYAxesReducer = (state: YAxisConfig, action: MultipleYAxesActions): YAxisConfig => {
    switch (action.type) {
        case 'setColumn':
            return { ...state, columns: [action.column] };
        case 'setLabel': {
            return { ...state, label: action.label };
        }
        case 'updateYAxisLimit': {
            return { ...updateYAxisLimit(state, action.property, action.value) };
        }
        case 'setYAxisScale': {
            return { ...state, yAxisScale: action.yAxisScale };
        }
    }
    assertNever(action);
};

export const updateYAxisLimit = (
    state: YAxisConfig,
    property: 'yAxisMinimumValue' | 'yAxisMaximumValue',
    value: string
): YAxisConfig => {
    let { yAxisMinimumValue, yAxisMaximumValue } = state;
    switch (property) {
        case 'yAxisMaximumValue':
            yAxisMaximumValue = convertStringToNumber(value);
            break;
        case 'yAxisMinimumValue':
            yAxisMinimumValue = convertStringToNumber(value);
            break;
    }

    if (yAxisMinimumValue !== null && yAxisMaximumValue !== null) {
        switch (property) {
            case 'yAxisMinimumValue':
                if (yAxisMaximumValue < yAxisMinimumValue) {
                    yAxisMaximumValue = yAxisMinimumValue;
                }
                break;
            case 'yAxisMaximumValue':
                if (yAxisMinimumValue > yAxisMaximumValue) {
                    yAxisMinimumValue = yAxisMaximumValue;
                }
                break;
        }
    }
    return { ...state, yAxisMaximumValue, yAxisMinimumValue };
};
